import React from 'react';

const Field = ({
  label,
  required = false,
  type = 'text',
  value,
  onChange,
  name,
  placeholder,
  error,
  disabled = false,
  inputProps = {}
}) => {
  return (
    <div className="form-group" style={{ marginBottom: 10 }}>
      {label && (
        <label
          className="pd10botbuilder"
          style={{
            display: 'block',
            marginBottom: 5,
            fontWeight: 500,
            color: disabled ? '#a0a0a0' : '#495057' 
          }}
        >
          {label}
          {required && <span style={{ color: 'red' }}>*</span>}
        </label>
      )}
      <input
        type={type}
        name={name}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled} 
        style={{
          border: error ? '1px solid #dc3545' : '1px solid #e1e5e9',
          borderRadius: '5px',
          padding: '10px 15px',
          fontSize: '13px',
          backgroundColor: disabled ? '#f5f5f5' : '#fff',
          color: disabled ? '#6c757d' : '#212529',
          cursor: disabled ? 'not-allowed' : 'text'
        }}
        {...inputProps}
      />
      {error && (
        <div
          className="invalid-feedback d-block"
          style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default Field;
